/*eslint-disable react/no-unknown-property */
const LoginMobileSVG = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="32" className="Login-mobile-svgbg" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 62C48.5685 62 62 48.5685 62 32C62 15.4315 48.5685 2 32 2C15.4315 2 2 15.4315 2 32C2 48.5685 15.4315 62 32 62ZM32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
        className="login-mobile-outline-SVG"
      />
      <path
        d="M41.2775 46.9812C41.2463 46.9837 41.22 47 41.1875 47H27.7501C25.6826 47 24.0001 45.3175 24.0001 43.25V42.0001C24.0001 41.31 24.5599 40.7499 25.25 40.7499C25.9401 40.7499 26.4999 41.31 26.4999 42.0001V43.25C26.4999 43.9387 27.0612 44.4999 27.7501 44.4999H33.5738L33.1925 44.3724C32.1801 44.0225 31.5001 43.0687 31.5001 42.0001V23.2501H27.7501C27.0612 23.2501 26.4999 23.8113 26.4999 24.5V27.0001C26.4999 27.6899 25.9401 28.25 25.25 28.25C24.5599 28.25 24.0001 27.6899 24.0001 27.0001V24.5C24.0001 22.4325 25.6826 20.75 27.7501 20.75H31.5001V19.5001C31.5001 18.1213 32.6212 17 33.9999 17C34.2675 17 34.5213 17.0387 34.7962 17.1238L42.3063 19.6276C43.32 19.9775 44 20.9313 44 21.9999V44.4999C44 45.9574 42.7437 47.1 41.2775 46.9812V46.9812Z"
        className="login-mobile-outline-SVG"
      />
      <path
        d="M27.3836 35.3838L22.3837 40.3837C22.0262 40.7412 21.4888 40.8488 21.0212 40.6549C20.5549 40.4613 20.2501 40.0049 20.2501 39.5V35.75H15.2499C14.5601 35.75 14 35.1899 14 34.5001C14 33.81 14.5601 33.2499 15.2499 33.2499H20.2501V29.4999C20.2501 28.995 20.5549 28.5389 21.0212 28.345C21.4888 28.1514 22.0262 28.2587 22.3837 28.6162L27.3836 33.6164C27.8725 34.105 27.8725 34.8949 27.3836 35.3838Z"
        className="login-mobile-outline-SVG"
      />
    </svg>
  );
};

const ClearSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 15.0187L13.4813 12.5L16 9.98131L15.0187 9L12.5 11.5187L9.98131 9L9 9.98131L11.5187 12.5L9 15.0187L9.98131 16L12.5 13.4813L15.0187 16L16 15.0187ZM7.1831 7.21831C8.66198 5.73943 10.4343 5 12.5 5C14.5657 5 16.3322 5.73356 17.7993 7.2007C19.2664 8.66785 20 10.4343 20 12.5C20 14.5657 19.2664 16.3322 17.7993 17.7993C16.3322 19.2664 14.5657 20 12.5 20C10.4343 20 8.66785 19.2664 7.2007 17.7993C5.73356 16.3322 5 14.5657 5 12.5C5 10.4343 5.72769 8.67372 7.1831 7.21831Z"
      className="login-input-outline-SVG"
    />
  </svg>
);
const PersonSVG = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.88304 15.8304C8.83822 15.0351 10.7105 14.6374 12.5 14.6374C14.2895 14.6374 16.1535 15.0268 18.0921 15.8056C20.0307 16.5843 21 17.6033 21 18.8626V21H4V18.8626C4 17.6033 4.961 16.5926 6.88304 15.8304ZM15.4825 11.2573C14.654 12.0858 13.6598 12.5 12.5 12.5C11.3402 12.5 10.346 12.0858 9.51754 11.2573C8.68908 10.4288 8.27485 9.4347 8.27485 8.27485C8.27485 7.115 8.68908 6.11258 9.51754 5.26754C10.346 4.42251 11.3402 4 12.5 4C13.6598 4 14.654 4.42251 15.4825 5.26754C16.3109 6.11258 16.7251 7.115 16.7251 8.27485C16.7251 9.4347 16.3109 10.4288 15.4825 11.2573Z"
        className="login-input-outline-SVG"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="17"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.88304 15.8304C8.83822 15.0351 10.7105 14.6374 12.5 14.6374C14.2895 14.6374 16.1535 15.0268 18.0921 15.8056C20.0307 16.5843 21 17.6033 21 18.8626V21H4V18.8626C4 17.6033 4.961 16.5926 6.88304 15.8304ZM15.4825 11.2573C14.654 12.0858 13.6598 12.5 12.5 12.5C11.3402 12.5 10.346 12.0858 9.51754 11.2573C8.68908 10.4288 8.27485 9.4347 8.27485 8.27485C8.27485 7.115 8.68908 6.11258 9.51754 5.26754C10.346 4.42251 11.3402 4 12.5 4C13.6598 4 14.654 4.42251 15.4825 5.26754C16.3109 6.11258 16.7251 7.115 16.7251 8.27485C16.7251 9.4347 16.3109 10.4288 15.4825 11.2573Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)"></g>
    </svg>
  );
};
//const DisplayPasswordSVG=()=>{
//return(<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
//<path fillRule="evenodd" clipRule="evenodd" d="M12 5C7.45455 5 3.57273 7.9545 2 12.125C3.57273 16.2955 7.45455 19.25 12 19.25C16.5455 19.25 20.4273 16.2955 22 12.125C20.4273 7.9545 16.5455 5 12 5ZM12.5 16.1964C10.016 16.1964 8 14.3724 8 12.125C8 9.87757 10.016 8.05357 12.5 8.05357C14.984 8.05357 17 9.87757 17 12.125C17 14.3724 14.984 16.1964 12.5 16.1964ZM12.5 9.07143C10.5633 9.07143 9 10.4354 9 12.125C9 13.8146 10.5633 15.1786 12.5 15.1786C14.4367 15.1786 16 13.8146 16 12.125C16 10.4354 14.4367 9.07143 12.5 9.07143Z" className="login-input-outline-SVG"/>
//</svg>
//);
//};

const DisplayPasswordSVG = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.125 20C23.125 20.8288 22.7958 21.6237 22.2097 22.2097C21.6237 22.7958 20.8288 23.125 20 23.125C19.1712 23.125 18.3763 22.7958 17.7903 22.2097C17.2042 21.6237 16.875 20.8288 16.875 20C16.875 19.1712 17.2042 18.3763 17.7903 17.7903C18.3763 17.2042 19.1712 16.875 20 16.875C20.8288 16.875 21.6237 17.2042 22.2097 17.7903C22.7958 18.3763 23.125 19.1712 23.125 20V20Z"
        fill="#263154"
      />
      <path
        d="M10 20C10 20 13.75 13.125 20 13.125C26.25 13.125 30 20 30 20C30 20 26.25 26.875 20 26.875C13.75 26.875 10 20 10 20ZM20 24.375C21.1603 24.375 22.2731 23.9141 23.0936 23.0936C23.9141 22.2731 24.375 21.1603 24.375 20C24.375 18.8397 23.9141 17.7269 23.0936 16.9064C22.2731 16.0859 21.1603 15.625 20 15.625C18.8397 15.625 17.7269 16.0859 16.9064 16.9064C16.0859 17.7269 15.625 18.8397 15.625 20C15.625 21.1603 16.0859 22.2731 16.9064 23.0936C17.7269 23.9141 18.8397 24.375 20 24.375V24.375Z"
        fill="#263154"
      />
    </svg>
  );
};

const HidePasswordSVG = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4875 26.139L21.47 24.1203C20.6898 24.3992 19.8464 24.4509 19.038 24.2692C18.2296 24.0876 17.4894 23.6801 16.9035 23.0942C16.3176 22.5084 15.9102 21.7682 15.7285 20.9597C15.5469 20.1513 15.5986 19.308 15.8775 18.5278L13.3025 15.9528C11.1725 17.8465 10 19.999 10 19.999C10 19.999 13.75 26.874 20 26.874C21.2005 26.8699 22.3874 26.6197 23.4875 26.139V26.139ZM16.5125 13.859C17.6126 13.3783 18.7995 13.1282 20 13.124C26.25 13.124 30 19.999 30 19.999C30 19.999 28.8263 22.1503 26.6988 24.0465L24.1212 21.469C24.4002 20.6888 24.4519 19.8455 24.2702 19.037C24.0886 18.2286 23.6811 17.4884 23.0952 16.9025C22.5093 16.3167 21.7691 15.9092 20.9607 15.7276C20.1523 15.5459 19.3089 15.5976 18.5287 15.8765L16.5125 13.8603V13.859Z"
        fill="#263154"
      />
      <path
        d="M16.9054 19.5566C16.8366 20.037 16.8807 20.5268 17.0341 20.9872C17.1875 21.4476 17.446 21.866 17.7892 22.2091C18.1323 22.5523 18.5507 22.8108 19.0111 22.9642C19.4715 23.1176 19.9613 23.1617 20.4416 23.0929L16.9041 19.5566H16.9054ZM23.0929 20.4416L19.5566 16.9041C20.037 16.8354 20.5268 16.8794 20.9872 17.0328C21.4476 17.1862 21.866 17.4448 22.2091 17.7879C22.5523 18.1311 22.8108 18.5494 22.9642 19.0098C23.1176 19.4702 23.1617 19.96 23.0929 20.4404V20.4416ZM27.0566 27.9416L12.0566 12.9416L12.9416 12.0566L27.9416 27.0566L27.0566 27.9416Z"
        fill="#263154"
      />
    </svg>
  );
};

const PasswordSVG = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7807 9.03125V7.01562C15.7807 6.17187 15.4576 5.44532 14.8114 4.83594C14.1652 4.22656 13.3947 3.92188 12.5 3.92188C11.6053 3.92188 10.8348 4.22656 10.1886 4.83594C9.54239 5.44532 9.2193 6.17187 9.2193 7.01562V9.03125H15.7807ZM11.0088 17.4219C11.4396 17.8281 11.9366 18.0312 12.5 18.0312C13.0634 18.0312 13.5604 17.8281 13.9912 17.4219C14.422 17.0156 14.6374 16.5469 14.6374 16.0156C14.6374 15.4844 14.422 15.0156 13.9912 14.6094C13.5604 14.2031 13.0634 14 12.5 14C11.9366 14 11.4396 14.2031 11.0088 14.6094C10.578 15.0156 10.3626 15.4844 10.3626 16.0156C10.3626 16.5469 10.578 17.0156 11.0088 17.4219ZM18.8626 9.03125C19.4259 9.03125 19.923 9.22656 20.3538 9.61719C20.7846 10.0078 21 10.4687 21 11V21.0312C21 21.5625 20.7846 22.0234 20.3538 22.4141C19.923 22.8047 19.4259 23 18.8626 23H6.13743C5.57407 23 5.077 22.8047 4.6462 22.4141C4.2154 22.0234 4 21.5625 4 21.0312V11C4 10.4687 4.2154 10.0078 4.6462 9.61719C5.077 9.22656 5.57407 9.03125 6.13743 9.03125H7.18129V7.01562C7.18129 5.64062 7.70321 4.46094 8.74708 3.47656C9.79094 2.49218 11.0419 2 12.5 2C13.9581 2 15.2091 2.49218 16.2529 3.47656C17.2968 4.46094 17.8187 5.64062 17.8187 7.01562V9.03125H18.8626Z"
        className="login-input-outline-SVG"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="2"
        width="17"
        height="21"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7807 9.03125V7.01562C15.7807 6.17187 15.4576 5.44532 14.8114 4.83594C14.1652 4.22656 13.3947 3.92188 12.5 3.92188C11.6053 3.92188 10.8348 4.22656 10.1886 4.83594C9.54239 5.44532 9.2193 6.17187 9.2193 7.01562V9.03125H15.7807ZM11.0088 17.4219C11.4396 17.8281 11.9366 18.0312 12.5 18.0312C13.0634 18.0312 13.5604 17.8281 13.9912 17.4219C14.422 17.0156 14.6374 16.5469 14.6374 16.0156C14.6374 15.4844 14.422 15.0156 13.9912 14.6094C13.5604 14.2031 13.0634 14 12.5 14C11.9366 14 11.4396 14.2031 11.0088 14.6094C10.578 15.0156 10.3626 15.4844 10.3626 16.0156C10.3626 16.5469 10.578 17.0156 11.0088 17.4219ZM18.8626 9.03125C19.4259 9.03125 19.923 9.22656 20.3538 9.61719C20.7846 10.0078 21 10.4687 21 11V21.0312C21 21.5625 20.7846 22.0234 20.3538 22.4141C19.923 22.8047 19.4259 23 18.8626 23H6.13743C5.57407 23 5.077 22.8047 4.6462 22.4141C4.2154 22.0234 4 21.5625 4 21.0312V11C4 10.4687 4.2154 10.0078 4.6462 9.61719C5.077 9.22656 5.57407 9.03125 6.13743 9.03125H7.18129V7.01562C7.18129 5.64062 7.70321 4.46094 8.74708 3.47656C9.79094 2.49218 11.0419 2 12.5 2C13.9581 2 15.2091 2.49218 16.2529 3.47656C17.2968 4.46094 17.8187 5.64062 17.8187 7.01562V9.03125H18.8626Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)"></g>
    </svg>
  );
};

export {
  LoginMobileSVG,
  ClearSVG,
  PersonSVG,
  DisplayPasswordSVG,
  HidePasswordSVG,
  PasswordSVG,
};
